import React from 'react';
import { Page, View, Text } from '@react-pdf/renderer';
import { styles, COLORS } from './styles';
import { PageOffsetContext } from './shared';

/**
 * Reusable page wrapper with header + footer.
 *
 * Props:
 *   reportTitle   – string shown left of header
 *   sectionTitle  – string shown right of header
 *   accentColor   – color used for h2 headings (defaults to navy)
 *   style         – extra styles merged onto <Page>
 */
export default function PageTemplate({
  reportTitle = '2024 CSC Impact Report',
  sectionTitle = '',
  accentColor = COLORS.navy,
  hideHeader = false,
  style,
  children,
}) {
  const { pageOffset, totalDocPages } = React.useContext(PageOffsetContext);
  return (
    <Page size="LETTER" orientation='landscape' style={[styles.page, style]}>
      {/* Header */}
      {!hideHeader && (
        <View style={styles.header} fixed>
          <Text style={styles.headerTitle} render={() => reportTitle} />
          {sectionTitle ? (
            <Text
              style={[styles.headerTitle, { textTransform: 'none', fontWeight: 400 }]}
              render={({ pageNumber }) => `${sectionTitle}  ${pageNumber + pageOffset}`}
            />
          ) : null}
        </View>
      )}

      {/* Content */}
      {children}

      {/* Footer */}
      <View style={styles.footer} fixed>
        <Text style={styles.footerText}>
          © {new Date().getFullYear()} Columbia Sportswear Company
        </Text>
        <Text
          style={styles.footerText}
          render={({ pageNumber, totalPages }) =>
            `${pageNumber + pageOffset} / ${totalDocPages ?? totalPages}`
          }
        />
      </View>
    </Page>
  );
}
